import { createFileRoute } from '@tanstack/react-router';
import { EmptyState } from '@/components/page-header';
import { PayBillsForm } from '@/components/purchases/pay-bills-form';
import { useOrgId } from '@/lib/org';

export const Route = createFileRoute('/expenses/pay-bills')({
  component: PayBills,
  validateSearch: (s: Record<string, unknown>): { billId?: string; contactId?: string } => ({
    ...(typeof s['billId'] === 'string' ? { billId: s['billId'] } : {}),
    ...(typeof s['contactId'] === 'string' ? { contactId: s['contactId'] } : {}),
  }),
});

function PayBills() {
  const orgId = useOrgId();
  const s = Route.useSearch();
  if (!orgId)
    return <EmptyState title="Select a client" hint="Use the client switcher in the top bar." />;
  return <PayBillsForm key={orgId} {...s} />;
}
